import React, { useState } from "react";
import {
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Button,
  Box,
} from "@chakra-ui/react";
import { useRouter } from "next/router";
const ContactThankyou = ({ isOpenModal, setToggle}) => {
    
    const router=useRouter();
    const goToPage = async (page) => {
        router.push(page);
        setToggle(!isOpenModal);
    };
    
    return (<Modal
        isOpen={isOpenModal}
        isCentered
        size="full"
        onClose={() => {
          setToggle(!isOpenModal);
        }}
      >
        <ModalOverlay />
        <ModalContent px={0}>
            <ModalBody px={3} pb={12}>
                <Flex w="100%" flexDirection="column" bg="white" maxH="500px">
                    <Box className="mx-auto">
                        <img className="w-[70%] mx-auto" src="/assets/request-sent-img.png"></img>
                    </Box>
                    <h2 className="heading-color text-center mb-2">Thank You for Reaching Out! 🙌</h2>
                    <p className="text-black text-center mb-4">Your message has been successfully submitted.</p>
                    <p className="text-black text-center mb-4">Our team will review your inquiry and get back to you within 24 hours.<br/> In the meantime, feel free to explore more on our platform or check out our FAQs.</p>
                    <p className="text-black text-center mb-4">We appreciate your time and look forward to assisting you!</p>
                    
                    <Box className="flex justify-center gap-3 mt-2 mb-4">
                        <Button id="submitForm" type="button" className="dark-blue-btn" onClick={(e)=>goToPage('/')}>
                        Back to Home
                        </Button>
                        <Button  type="button" className="blue-outline-btn" onClick={(e)=>goToPage('/contact')}>
                        Contact Support
                        </Button>
                    </Box>
                </Flex>
            </ModalBody>
        </ModalContent>
      </Modal>
  );
};

export default ContactThankyou;
